import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { theme } from '../styles/theme';

const PageContainer = styled.div`
  min-height: 80vh;
  padding: ${theme.spacing['4xl']} ${theme.spacing.xl};
  background: ${theme.gradients.hero};
`;

const Container = styled.div`
  max-width: 1280px;
  margin: 0 auto;
`;

const PageHeader = styled.div`
  text-align: center;
  margin-bottom: ${theme.spacing['4xl']};
`;

const PageTitle = styled.h1`
  font-size: ${theme.typography.fontSize['4xl']};
  font-weight: ${theme.typography.fontWeight.bold};
  color: ${theme.colors.secondary[900]};
  margin-bottom: ${theme.spacing.lg};
`;

const ContentCard = styled.div`
  background: ${theme.colors.white};
  padding: ${theme.spacing['3xl']};
  border-radius: ${theme.borderRadius.lg};
  box-shadow: ${theme.shadows.lg};
`;

const SitemapGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: ${theme.spacing.xl};
`;

const SitemapSection = styled.div`
  h3 {
    color: ${theme.colors.secondary[900]};
    margin-bottom: ${theme.spacing.md};
    font-size: ${theme.typography.fontSize.lg};
  }
  
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    
    li {
      margin-bottom: ${theme.spacing.sm};
      
      a {
        color: ${theme.colors.primary[600]};
        text-decoration: none;
        font-size: ${theme.typography.fontSize.base};
        
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;

function Sitemap() {
  const { t } = useTranslation(['pages', 'navigation']);

  return (
    <PageContainer>
      <Container>
        <PageHeader>
          <PageTitle>{t('pages:sitemap.title')}</PageTitle>
        </PageHeader>
        
        <ContentCard>
          <SitemapGrid>
            <SitemapSection>
              <h3>{t('pages:sitemap.mainPages')}</h3>
              <ul>
                <li><Link to="/">{t('navigation:home')}</Link></li>
                <li><Link to="/servicios">{t('navigation:services')}</Link></li>
                <li><Link to="/nosotros">{t('navigation:about')}</Link></li>
                <li><Link to="/contacto">{t('navigation:contact')}</Link></li>
              </ul>
            </SitemapSection>
            
            <SitemapSection>
              <h3>{t('pages:sitemap.legal')}</h3>
              <ul>
                <li><Link to="/cookies">{t('pages:sitemap.cookiePolicy')}</Link></li>
                <li><Link to="/terminos">{t('pages:sitemap.terms')}</Link></li>
              </ul>
            </SitemapSection>
          </SitemapGrid>
        </ContentCard>
      </Container>
    </PageContainer>
  );
}

export default Sitemap;